import {
  GET_LIST_THONGKETHU,
  GET_LIST_THONGKETHU_SUCCESS,
  GET_LIST_THONGKETHU_FAILURE,
} from "./actionTypes";

export const getListThongKeThu = (dataSearch) => ({
  type: GET_LIST_THONGKETHU,
  dataSearch,
});

export const getListThongKeThuSuccess = (data) => ({
  type: GET_LIST_THONGKETHU_SUCCESS,
  payload: data,
});

export const getListThongKeThuFailure = () => ({
  type: GET_LIST_THONGKETHU_FAILURE,
});
